import React from 'react';

import GuestSidebar from './GuestSidebar';
import Sidebar from './Sidebar';

interface Props {
  setCurrentCompany: (id) => void;
  sidebarType: 'admin' | 'guest';
  otherProps: any;
}

const SidebarWrapper = ({
  setCurrentCompany,
  sidebarType,
  ...otherProps
}: Props) => {
  // const setCompanyId = useSetAtom(companyIdAtom);
  // const resetOnCompanyChangeAtoms = useOnCompanyChangeResetAtoms();

  // Define a function to update the companyId atom
  const updateCompanyId = (id) => {
    // Move to dashboard
    // resetOnCompanyChangeAtoms();
    setCurrentCompany(id);
    // setCompanyId(id);
  };

  // Render your class component and pass the updateCompanyId function as a prop
  return sidebarType === 'admin' ? (
    <Sidebar {...otherProps} setCompanyData={updateCompanyId} />
  ) : (
    <GuestSidebar {...otherProps} setCompanyData={updateCompanyId} />
  );
};

export default SidebarWrapper;
